import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 21.6V18A3.6 3.6 0 0 1 6 14.4h7.2m3 3 1.2 1.2 4.2-4.2M14.4 6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0"
    />
  </svg>
);
export default SvgUserProfileCheck;
